const SP_FORBIDDEN_CHARS = /[\\/\\\\'"]/g;

export const cleanForSP = value => {
  if (value === null || value === undefined) return value;
  if (typeof value !== 'string') return value;
  return value.replace(SP_FORBIDDEN_CHARS, '');
};

export const hasForbiddenSPChars = value => {
  if (value === null || value === undefined) return false;
  return SP_FORBIDDEN_CHARS.test(String(value));
};

export const sanitizeObjectForSP = value => {
  if (Array.isArray(value)) return value.map(item => sanitizeObjectForSP(item));

  if (value && typeof value === 'object') {
    return Object.keys(value).reduce((acc, key) => {
      acc[key] = sanitizeObjectForSP(value[key]);
      return acc;
    }, {});
  }

  return cleanForSP(value);
};

export const normalizeAntecedentesComentarios = value => {
  const empty = {
    otrasEnfermedades: '',
    comentariosObraSocial: ''
  };

  if (!value) return { ...empty };

  let parsed = value;

  if (typeof parsed === 'string') {
    try {
      parsed = JSON.parse(parsed || '{}');
    } catch (e) {
      parsed = {};
    }
  }

  if (Array.isArray(parsed)) {
    parsed = parsed[0] || {};
  }

  if (!parsed || typeof parsed !== 'object') {
    return { ...empty };
  }

  return sanitizeObjectForSP({
    otrasEnfermedades: parsed.otrasEnfermedades || '',
    comentariosObraSocial: parsed.comentariosObraSocial || ''
  });
};
